package router

sealed trait Page

case class AuthPage(service:  Option[String] = None, redirect: Option[String] = None) extends Page

case class MappingPage(clientId: Option[String], svc: Option[String]) extends Page

case class RemovalPage(clientId: Option[String], svc: Option[String]) extends Page
